// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"0a3b1ed2","563":"98205bf4"}[chunkId] + ".chunk.js";
};